export default __webpack_public_path__ + "static/media/elipse.56148601.png";